import {
  type AgentRunMutableAction,
  type AgentRunStatus,
  getAgentRunMutableActions,
} from "@qualtio-workhub/domain";
import type { TranslationKey } from "@qualtio-workhub/i18n";

type AgentRunActionView = AgentRunMutableAction & {
  labelKey: TranslationKey;
};

export type AgentRunTransitionStatus = Extract<
  AgentRunStatus,
  "running" | "waiting_for_human" | "completed" | "failed"
>;

export type AgentRunTransitionPayload =
  | { status: "running" }
  | { status: "waiting_for_human"; summary: string }
  | { status: "completed"; summary: string }
  | { status: "failed"; error: string };

type AgentRunDefaultTranslationKey = Extract<
  TranslationKey,
  "agents.defaultBlocker" | "agents.defaultError" | "agents.defaultSummary"
>;

const actionLabelKeys: Record<AgentRunMutableAction["id"], TranslationKey> = {
  mark_running: "agents.markRunning",
  request_human: "agents.requestHuman",
  complete: "agents.complete",
  fail: "agents.fail",
};

export function getAgentRunActionViews(status: AgentRunStatus): AgentRunActionView[] {
  return getAgentRunMutableActions(status).map((action) => ({
    ...action,
    labelKey: actionLabelKeys[action.id],
  }));
}

export function buildAgentRunTransitionPayload(
  status: AgentRunTransitionStatus,
  message: string,
  translate: (key: AgentRunDefaultTranslationKey) => string,
): AgentRunTransitionPayload {
  if (status === "running") {
    return { status };
  }
  if (status === "failed") {
    return { status, error: message || translate("agents.defaultError") };
  }
  if (status === "completed") {
    return { status, summary: message || translate("agents.defaultSummary") };
  }
  return { status, summary: message || translate("agents.defaultBlocker") };
}
